import homeData from '../data/home';
import { HtmlPage } from '../components/HtmlPage';
import { ProductGrid } from '../components/ProductGrid';
import { useLanguage } from '../context/LanguageContext';
export function HomePage(){
 const {t}=useLanguage(); const page=homeData as any;
 return <HtmlPage html={page.mainHtml} title={t('titleHome',page.title)} description={t('descriptionHome',page.description)} slots={{'product-grid':<ProductGrid/>}}/>;
}
